import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import { DeadlineDialog } from "@sprout/client-components/dist/Dialog_next";
import useToggle from "@sprout/hooks/dist/useToggle";
import { useCurrentUser, useSetItemsCompleted, useSetItemsStarred, useSetWhenForItems } from "@sprout/client-graphql";
import usePostPageSelfAssign from "./usePostPageSelfAssign";
export default function usePostPageSharedGlobalHandlers(item) {
    const { url  } = item;
    const authorization = usePostAuthorization(item);
    useActionRegistryGlobalHandler("PAGE_OPEN_EXTERNAL", useCallback(()=>{
        if (url) {
            window.open(url);
            return true;
        }
        return false;
    }, [
        url
    ]), {
        skip: !url
    });
    const setWhenForItems = useSetWhenForItems();
    useActionRegistryGlobalHandler("PAGE_WHEN_TODAY", useCallback(()=>{
        setWhenForItems({
            items: [
                item
            ],
            today: true
        });
        return true;
    }, [
        item,
        setWhenForItems
    ]), {
        skip: !authorization.schedule
    });
    useActionRegistryGlobalHandler("PAGE_WHEN_CLEAR", useCallback(()=>{
        setWhenForItems({
            items: [
                item
            ],
            when: null,
            whenReminder: null
        });
        return true;
    }, [
        item,
        setWhenForItems
    ]), {
        skip: !authorization.schedule
    });
    const setItemsCompleted = useSetItemsCompleted();
    const updateCompleted = useCallback(()=>{
        setItemsCompleted({
            items: [
                item
            ],
            completed: !item.completed
        });
    }, [
        item,
        setItemsCompleted
    ]);
    useActionRegistryGlobalHandler("PAGE_TOGGLE_COMPLETED", useCallback(()=>{
        updateCompleted();
        return true;
    }, [
        updateCompleted
    ]), {
        skip: !authorization.addTodo
    });
    const currentUser = useCurrentUser();
    const setItemsStarred = useSetItemsStarred();
    useActionRegistryGlobalHandler("PAGE_TOGGLE_PRIORITY", useCallback(()=>{
        setItemsStarred({
            items: [
                item
            ],
            starred: !item.currentUserHasStarred
        });
        return true;
    }, [
        item,
        setItemsStarred
    ]), {
        skip: !currentUser
    });
    usePostPageSelfAssign(item);
    const [dialog, openDialog, closeDialog] = useToggle();
    const items = useMemo(()=>[
            item
        ], [
        item
    ]);
    const handleSetDeadline = useCallback(({ deadline  })=>{
        closeDialog();
        setWhenForItems({
            items: items,
            deadline
        });
    }, [
        closeDialog,
        items,
        setWhenForItems
    ]);
    useActionRegistryGlobalHandler("PAGE_DEADLINE", useCallback(()=>{
        openDialog();
        return true;
    }, [
        openDialog
    ]), {
        skip: !authorization.schedule
    });
    return {
        elements: /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(DeadlineDialog, {
                items: items,
                open: dialog,
                onSetDeadline: handleSetDeadline,
                onRequestClose: closeDialog
            })
        })
    };
};
